import { View } from "react-native";
import TextLoader from "../shared/TextLoader";
import React from "react";
import TipLoader from "./TipLoader";
import Gap from "../../../../Gap";
import ContentScrollBarLoader from "../shared/ContentScrollBar/ContentScrollBarLoader";

const TipsterLoader = () => {
  return (
    <View>
      <Gap vertical size="xsmall" />
      <TextLoader height={20} />
      <Gap vertical size="small" />
      <ContentScrollBarLoader />
      <Gap vertical size="xsmall" />
      <TextLoader height={20} />
      <TipLoader />
      <TextLoader height={20} />
      <TipLoader />
      <TipLoader />
    </View>
  );
};
export default TipsterLoader;
